<template>
  <section class="loader-component">
    <img src="../../../public/img/Rolling-1s-200px.gif">
  </section>
</template>
<script>
import {} from '@/components';

export default {
  components: {},
  data(){
    return {}
  },
  mounted(){},
  methods:{}
}
</script>
<style lang="scss">
.loader-component{
    position: fixed;
    top: 0;
    z-index: 99999;
    width: 100%;
    background: #fff;
    text-align: center;
    height: 100vh;
    img{
      position: absolute;
      top: 45%;
      max-width: 285px;
      left: 50%;
      transform: translate(-50%, -50%);
    }
}

</style>
